var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalRibbonsStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.525,
    height: 48,
    viewBox: "0 0 50.525 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6192e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1213b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal-ribbons-star-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9032",
    "data-name": "Trazado 9032",
    d: "M22.684,37.368A17.684,17.684,0,1,0,5,19.684,17.684,17.684,0,0,0,22.684,37.368Zm0-25.263c-.718,0-1.2.861-2.158,2.583l-.248.446a2.777,2.777,0,0,1-.622.9,2.59,2.59,0,0,1-1.007.341l-.482.109c-1.864.422-2.8.633-3.018,1.346s.414,1.456,1.685,2.942l.329.384a2.792,2.792,0,0,1,.623.895,2.914,2.914,0,0,1,0,1.106l-.05.513c-.192,1.983-.288,2.974.292,3.415s1.453.039,3.2-.765l.451-.208a2.586,2.586,0,0,1,1.007-.343,2.586,2.586,0,0,1,1.007.343l.451.208c1.745.8,2.618,1.205,3.2.765s.484-1.432.292-3.415l-.05-.513a2.914,2.914,0,0,1,0-1.106,2.794,2.794,0,0,1,.623-.895l.329-.385c1.271-1.486,1.906-2.229,1.685-2.942S29.066,16.9,27.2,16.48l-.482-.109a2.59,2.59,0,0,1-1.007-.341,2.777,2.777,0,0,1-.622-.9l-.248-.446C23.882,12.966,23.4,12.105,22.684,12.105Z",
    transform: "translate(4.579 0)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9033",
    "data-name": "Trazado 9033",
    d: "M8.3,12.995l-3.8,3.932a11.416,11.416,0,0,0-2.283,2.717,2.919,2.919,0,0,0,1.094,3.592,9.6,9.6,0,0,0,3.3.609,8.455,8.455,0,0,1,2.009.334,3.62,3.62,0,0,1,2.109,2.183,9.325,9.325,0,0,1,.323,2.08,10.566,10.566,0,0,0,.588,3.412,2.718,2.718,0,0,0,3.47,1.133,11.226,11.226,0,0,0,2.625-2.364l6.27-6.493A21.494,21.494,0,0,1,8.3,12.995Z",
    transform: "translate(0 16.781)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9034",
    "data-name": "Trazado 9034",
    d: "M13.289,24.131l6.271,6.493a11.225,11.225,0,0,0,2.624,2.364,2.718,2.718,0,0,0,3.47-1.133,10.568,10.568,0,0,0,.588-3.412,9.33,9.33,0,0,1,.323-2.08,3.62,3.62,0,0,1,2.109-2.183,8.456,8.456,0,0,1,2.009-.334,9.6,9.6,0,0,0,3.3-.609,2.919,2.919,0,0,0,1.094-3.592,11.417,11.417,0,0,0-2.283-2.717l-3.8-3.932A21.494,21.494,0,0,1,13.289,24.131Z",
    transform: "translate(17.231 16.781)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalRibbonsStar);
export default __webpack_public_path__ + "static/media/medal-ribbons-star.104de0a5fcc618f86715cad43c5ea7c2.svg";
export { ForwardRef as ReactComponent };